/* eslint-disable react-hooks/exhaustive-deps */
import {
    AlertColor,
    Box,
    Button,
    Checkbox,
    Grid,
    Link,
    Snackbar,
    SnackbarOrigin,
    Typography,
    useMediaQuery,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { FC, useCallback, useEffect, useState } from "react";
import imgIntelbras from "./image-20240618-174726.png"
import { LocalStorage } from "src/framework/commons/LocalStorage";
import jwtDecode from "jwt-decode";
import api, { IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import React from "react";
import { Alert } from '@mui/material';
import { useHistory } from "react-router-dom";
import { LoginStore } from "src/framework/store/LoginStore";
import { InputText } from "src/framework/components/forms/inputs/InputText";
import { LogoSolar } from "src/framework/components/commons/LogoSolar";
import { manualLoading$ } from "src/framework/store/ApiEvents";
import { useObservable } from "src/framework/store/storeUtil";

const useStyles = makeStyles({
    page: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
    },
    imagem: {
        paddingTop: "100px"
    },
    footer: {
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: "absolute"
    },
    body:{
        margin: "0px",
        padding: "0px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center" 
    },
    sucesso:{
        backgroundColor: "green"
    },
    falha: {
        borderRadius: "10px",
        backgroundColor: "red"
    },
    buttonAcessar: {
        color: "#FFFFFF",
        backgroundColor: "#00B26B"
    },
    container: {
        display: "flex",
        height: "100%",
        width: "100%"
    }
});
interface State extends SnackbarOrigin {
    open: boolean;
  }

interface SnackbarProps {
    open: boolean;
    message: string;
    color: AlertColor;

}

const DEFAULT_SNACKBAR_STATE: SnackbarProps = {
    open: false,
    message: "",
    color: "error",
}

const AssociaDistribuidor: FC = () => {
    const [checked, setChecked] = useState(false);
    const [cnpjDistribuidor, setCnpjDistribuidor] = useState("");
    const classes = useStyles();
    const manualLoadingState = useObservable(manualLoading$);
    const [snackbarState, setSnackbarState] = useState<SnackbarProps>(DEFAULT_SNACKBAR_STATE);
    const [state] = React.useState<State>({
        open: false,
        vertical: 'top',
        horizontal: 'center',
      });
    const { vertical, horizontal } = state;
    const history = useHistory();
    const matchMdQry = useMediaQuery('(max-height: 768px)');
    
    const handleLogout = async()=>{
        const token = LocalStorage.get("solar.token")
        const decoded: any = jwtDecode(token)

        if (decoded?.type !== 'conta') {
          window.location.href = `${window.location.origin}/signout`
          return
        }

        const redirectURL = await LoginStore.doLogOutConta()
        if (redirectURL) window.location.href = redirectURL
    }

    
    const handleAccess = async()=>{
        let cnpj = cnpjDistribuidor;
        cnpj = cnpj?.replace(/[^a-zA-Z0-9]/g,'');

        const request: IDataRequest = {
            url: `/cadastros/contas/associar_distribuidor`,
            data: {
                distribuidor_cnpj_cpf: cnpj,
            }
          };
          
        manualLoading$.next(true)
        const response: IDataResponse = await api.post(request);
        if([STATUS_CODE.OK, STATUS_CODE.CREATED].includes(response.statusCode)){
            const data = response?.data[0];
            const userExtraInfo = LocalStorage.get("solar.userExtraInfo", true);

            userExtraInfo.distribuidor_id = data?.distribuidor_id || null;
            userExtraInfo.distribuidor_nome = data?.distribuidor_nome || null;
            userExtraInfo.distribuidor_cnpj_cpf = data?.distribuidor_cnpj_cpf || null;
            
            LoginStore.setUserInfo(userExtraInfo);
            LocalStorage.set("solar.userExtraInfo", userExtraInfo, true);
            
            setSnackbarState({
                open: true,
                message: "Distribuidor associado com sucesso!",
                color: "success",
            })

            setTimeout(()=>{
                manualLoading$.next(false)
                history.replace("/");
            },2000)
        }else{
            manualLoading$.next(false)
            setSnackbarState({
                open: true,
                message: "O CNPJ informado não corresponde a um distribuidor. Informe outro CNPJ e tente novamente.",
                color: "error",
            })
        }
    }
    const handleClose = () => {
        setSnackbarState(DEFAULT_SNACKBAR_STATE);
    };

    const maskCnpj = useCallback((cnpj: string)=>{
        let _cnpj = cnpj;
        
        _cnpj = _cnpj.replace(/[^A-Za-z0-9]/g, "");
        _cnpj = _cnpj.replace(/(\d{2})(\d)/, "$1.$2");
        _cnpj = _cnpj.replace(/(\d{3})(\d)/, "$1.$2");
        _cnpj = _cnpj.replace(/(\d{3})(\d)/, "$1/$2");
        _cnpj = _cnpj.replace(/(\d{2}.\d{3}.\d{3}\/\d{4}-|\d{2}.\d{3}.\d{3}\/\d{4})(\d{1,})$/, "$1-$2");
        
        return _cnpj;
    },[cnpjDistribuidor])

    const usuarioIntelbras = (email: string) => {
        if (/@intelbras.com.br\s*$/.test(email)) {
          return true;
        }
        return false;
      }

    useEffect(()=>{
        if(history.location.pathname === "/associar_distribuidor"){
            const info = LocalStorage.get("solar.userExtraInfo", true);
            const usuarioInterno = usuarioIntelbras(info?.email);

            if(info?.isDistribuidor || usuarioInterno || info?.distribuidor_cnpj_cpf){
                history.replace("/");
            }
        }
    },[history.location.pathname])
    const disabled = manualLoadingState || !checked || !cnpjDistribuidor || (!!cnpjDistribuidor && (cnpjDistribuidor.replace(/[^a-zA-Z0-9]/g,'')).length < 14);
    return (
        <>
            <Grid container direction="column" justifyContent="center" alignItems="center">
                <Grid className={classes.page} style={{marginTop: !matchMdQry ? "80px" : "0px"}} container>
                        <Grid size={12}>
                            <Box className={classes.imagem} justifyContent='center' alignItems='center' style={{marginBottom: "10px"}}>
                                <img style={{height: "80px", width:"440px"}} src={imgIntelbras} alt="Imagem da Intelbras"/>
                            </Box>
                        </Grid>
                        <Grid size={12}>
                            <Typography style={{marginTop: "20px"}} variant="body1">
                                Bem-vindo ao seu primeiro acesso à Plataforma Solar Intelbras. Por favor, informe o CNPJ do Distribuidor Autorizado Intelbras que atende sua empresa em Energia Solar.
                            </Typography>
                        </Grid>
                        <Grid size={12}>
                            <InputText
                                placeholder="__.___.___/____-__"
                                style={{marginTop: "20px"}}
                                value={maskCnpj(cnpjDistribuidor)}
                                mask="cnpj"
                                onBlur={(e: any)=>setCnpjDistribuidor(e.target.value)}
                                onFocus={(e: any)=>setCnpjDistribuidor(e.target.value)}
                                onChange={(e: any)=>{
                                setCnpjDistribuidor(e.target.value)
                            }}/>
                        </Grid>
                        <Grid size={12}>
                            <Box  style={{marginTop: "30px"}} py={2} borderRadius="8px" bgcolor="#E6E6E6" borderLeft={"10px solid #00B26B"} textAlign={'left'} padding={'10px'}>
                                <Box style={{display: "flex", alignItems: "center"}}>
                                    <Checkbox 
                                        checked={checked}
                                        onChange={()=>setChecked(!checked)}
                                    />
                                    <Typography>
                                        Concordo que li e estou de acordo com os <Link target="_blank" href="https://www.intelbras.com/pt-br/politica-de-privacidade/termos">Termos de Uso</Link> e <Link target="_blank" href="https://www.intelbras.com/pt-br/politica-de-privacidade/politica">Políticas de Privacidade</Link>
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid size={12}>
                            <Button style={{backgroundColor: disabled ? "#E0E0E0" : "#00B26B", marginTop: "25px"}} disabled={disabled}
                                onClick={handleAccess}
                            >
                                <Box style={{color: disabled ? "#A6A6A6": "#FFFFFF"}}>
                                    <strong>Acessar</strong>
                                </Box>
                            </Button>
                        </Grid>
                        <Grid size={12}>
                            <Button onClick={handleLogout}>
                                Sair
                            </Button>
                        </Grid>
                    </Grid>
                    <Box className={classes.footer}>
                        <Box>
                            <LogoSolar fillIntelbras={"#00B26B"}/>
                            <Typography>
                                Intelbras © {new Date().getFullYear()} - 
                                <Link target="_blank" href="https://www.intelbras.com/pt-br/politica-de-privacidade/politica"> Privacidade </Link>
                                - 
                                <Link target="_blank" href="https://www.intelbras.com/pt-br/politica-de-privacidade/termos"> Termos</Link>
                            </Typography>
                        </Box>
                    </Box>
                    <Snackbar 
                    anchorOrigin={{ vertical, horizontal }}
                    open={snackbarState.open} autoHideDuration={5000} onClose={handleClose}>
                        <Alert
                            onClose={handleClose}
                            severity={snackbarState.color}
                            variant="standard"
                        >
                        {snackbarState.message}
                        </Alert>
                    </Snackbar>
                </Grid>
        </>
    );
}

export { AssociaDistribuidor }
